import moment from "moment";
import { toast } from "react-toastify";

export const validateRequiredFields = (fields) => {
  for (const field of fields) {
    // Check if the field value is empty
    if (!field.value) {
      toast.error(`${field.label}.`);
      return false; // Return false if any field is empty
    }
  }
  return true; // Return true if all required fields are filled
};

export const DateisValid = (date, formate = "DD/MM/YYYY", showTime = false) => {
  if (!date) return "-";

  if (showTime) {
    return moment(date).format(`${formate} hh:mm A`);
  } else {
    return moment(date).format(formate);
  }
};